import { ProtocolContentData } from "../../protocol";
export default class FreeEntryData extends ProtocolContentData {
    title;
    freeText;
    constructor(title, freeText) {
        super();
        this.title = title;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=FreeEntryData.js.map